import { Reveal, SectionLabel } from "./shared";

const beat = [
  { letter: "B", word: "Belief" },
  { letter: "E", word: "Emotion" },
  { letter: "A", word: "Attention" },
  { letter: "T", word: "Thought" },
];

export const HowWeWork = () => (
  <section className="py-24 md:py-36 bg-[#F3EFE5]" data-testid="how-we-work-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
      <div className="lg:col-span-7">
        <Reveal>
          <SectionLabel testId="how-we-work-label">How We Work</SectionLabel>
          <h2
            className="font-heading text-3xl sm:text-4xl md:text-[2.75rem] font-semibold tracking-tight text-[#1F2043] leading-[1.15]"
            data-testid="how-we-work-headline"
          >
            Inner readiness comes before outer readiness.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="font-body mt-9 text-base md:text-lg font-light leading-relaxed text-[#3C3C3B]" data-testid="how-we-work-paragraph-one">
            Every young person we work with meets moments that hijack them &mdash; a limiting
            belief, a wave of shame, a copied choice, a spiral of thought after one setback.
            Skills don&rsquo;t matter much if these patterns run the show.
          </p>
          <p className="font-body mt-6 text-base md:text-lg font-light leading-relaxed text-[#3C3C3B]" data-testid="how-we-work-paragraph-two">
            Our BEAT Psychology Framework &mdash; Belief, Emotion, Attention, Thought &mdash; helps
            young people notice these patterns and respond instead of react. It sits underneath
            everything we do.
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-5">
        <div className="grid grid-cols-2 gap-4 md:gap-5">
          {beat.map((item, i) => (
            <Reveal key={item.letter} delay={0.1 + i * 0.08} testId={`beat-chip-${item.word.toLowerCase()}`}>
              <div className="bg-white rounded-3xl border border-[#1F2043]/5 shadow-[0_8px_30px_rgb(31,32,67,0.04)] px-6 py-7 md:py-9">
                <span className="font-heading text-3xl md:text-4xl font-bold text-[#00867A]">
                  {item.letter}
                </span>
                <p className="font-heading mt-2 text-sm md:text-base font-medium text-[#1F2043] tracking-wide">
                  {item.word}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
